import { UploadLog } from '@/common/api/params/upload'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { SearchConditionBase } from '@/common/util/search'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import UploadLogListRow from '@/components/container/modules/master/upload/table/UploadLogListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

const COLUMNS = [
  'ID',
  'ファイル名',
  'マスタ種別',
  'ステータス',
  '行数',
  '新規',
  '更新',
  'スキップ',
  // 全件置き換えで削除した行数（add-w2-ex-product-spec で追加）
  '削除',
  'エラー',
  '取込元',
  // 受付→開始が待ち時間、開始→終了が処理時間（upload-log-timings）
  '受付',
  '開始',
  '終了',
  '待ち時間',
  '処理時間',
  '操作'
]

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {COLUMNS.map((col, i) => (
        <TableHeadItem key={col} float={float} {...rectProps(i)}>
          <Text size={12} color={TextColor.SECONDARY} nowrap>
            {col}
          </Text>
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  logs: UploadLog[]
  total: number
  condition: SearchConditionBase
  onUpdatePage: (page: number) => void
  retryingId: number | null
  onRetry: (log: UploadLog) => void
  onShowErrors: (log: UploadLog) => void
}

const UploadLogListTable = ({
  logs,
  total,
  condition,
  onUpdatePage,
  retryingId,
  onRetry,
  onShowErrors
}: Props) => {
  const listFollowProps = useListScrollFollow(COLUMNS.length)
  const theadProps: TheadProps = { ...listFollowProps.header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {logs.map((log) => (
            <UploadLogListRow
              key={log.id}
              log={log}
              retrying={retryingId === log.id}
              onRetry={onRetry}
              onShowErrors={onShowErrors}
            />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default UploadLogListTable
